export const setQrCode = (data) => {
  if (data) {
    const qrCode = {
      dealerCode: data?.dealerCode,
      storeMasterName: data?.storeMasterName,
      storeName: data?.storeName,
      lineName: data?.lineName,
      telephone: data?.telephone,
    };
    const text = JSON.stringify(qrCode);
    return text;
  }
  return '';
};
